/* eslint-disable max-len */
import { useTranslation } from 'react-i18next';
import { ManageBoreholesColumn } from './manageBoreholesColumns';

export interface ManageBoreholesTableHeadProps {
  columns: ManageBoreholesColumn[];
};

export const ManageBoreholesTableHead = (props: ManageBoreholesTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
};
